import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { RevendedorActionColumn } from 'pages/revendedor/revendedor/components';
import { useQueryRevendedor } from 'pages/revendedor/revendedor/hooks';
import { Revendedor } from 'pages/revendedor/revendedor/types';
import { brlCnpj, brlCpf, brlPercentual, brlPhone, brlPrice } from 'util/format';

const getRows = (data: Revendedor[] | undefined): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item) => ({
            id: item.idRevendedor,
            cdRevendedor: item.cdRevendedor,
            dsDocumento: item.dsDocumento,
            dsNome: item.dsNome,
            dsEmail: item.dsEmail,
            arquivo: item.arquivo,
            fgAtivo: item.fgAtivo,
            fgAprovado: item.fgAprovado,
            dsTelefone: item.dsTelefone,
            peDesconto: item.peDesconto,
            vlMinimoDesconto: item.vlMinimoDesconto,
        }));
    }
    return [];
};

const columns: GridColDef[] = [
    { field: 'dsNome', headerName: 'Nome', flex: 1 },
    {
        field: 'dsDocumento',
        headerName: 'Documento',
        width: 150,
        valueFormatter: (value: string) => (value.length === 14 ? brlCnpj(value) : brlCpf(value)),
    },
    { field: 'dsEmail', headerName: 'E-mail', flex: 1 },
    { field: 'dsTelefone', headerName: 'Telefone', width: 130, valueFormatter: (value) => brlPhone(value) },
    {
        field: 'peDesconto',
        headerName: 'Percentual do desconto',
        type: 'number',
        width: 130,
        valueFormatter: (value) => brlPercentual(value),
    },
    {
        field: 'vlMinimoDesconto',
        headerName: 'Valor mínimo',
        type: 'number',
        width: 130,
        valueFormatter: (value) => brlPrice(value),
    },
    { field: 'fgAtivo', headerName: 'Ativo', type: 'boolean' },
    { field: 'fgAprovado', headerName: 'Aprovado', type: 'boolean' },
    {
        field: 'acoes',
        align: 'center',
        headerAlign: 'center',
        headerName: 'Ações',
        sortable: false,
        renderCell: ({ row }) => <RevendedorActionColumn row={row} />,
    },
];

export function RevendedorGrid() {
    const { data, refetch, isFetching } = useQueryRevendedor();

    return (
        <Block>
            <PanelGrid rows={getRows(data?.data)} rowsCount={data?.total ?? 0} reload={refetch} loading={isFetching} columns={columns} />
        </Block>
    );
}
